import React from 'react'
import CouponMenuIcon from './assets/icons/CouponMenuIcon.png'
import CustomersMenuIcon from './assets/icons/CustomersMenuIcon.png'
import DashboardMenuIcon from './assets/icons/DashboardMenuIcon.png'
import MyPageMenuIcon from './assets/icons/MyPageMenuIcon.png'
import OrdersMenuIcon from './assets/icons/OrdersMenuIcon.png'
import ProductsMenuIcon from './assets/icons/ProductsMenuIcon.png'
import ChatMenuIcon from './assets/icons/ChatMenuIcon.png'
import { CImage, CNavGroup, CNavItem } from '@coreui/react-pro'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
  },
  // {
  //   component: CNavItem,
  //   name: 'Coupons',
  //   to: '/coupons/list',
  //   icon: <CImage fluid src={CouponMenuIcon} className='me-2' />,
  // },
  {
    component: CNavItem,
    name: 'My Page',
    to: '/my-page',
    icon: <CImage fluid src={MyPageMenuIcon} className='me-2' />,
  },
  {
    component: CNavItem,
    name: 'Purchases',
    to: '/purchases/list',
    icon: <CImage fluid src={OrdersMenuIcon} className='me-2' />,
  },
  {
    component: CNavGroup,
    name: 'Vouchers',
    icon: <CImage fluid src={ProductsMenuIcon} className='me-2' />,
    items: [
      {
        component: CNavItem,
        name: 'Voucher List',
        to: '/products/list',
      },
      {
        component: CNavItem,
        name: 'Game Type',
        to: '/products/category/list',
      },
      {
        component: CNavItem,
        name: 'Game List',
        to: '/products/sub-category/list',
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Chat',
    to: '/chat',
    icon: <CImage fluid src={ChatMenuIcon} className='me-2' />,
  },
  {
    component: CNavItem,
    name: 'Customers',
    to: '/customers/list',
    icon: <CImage fluid src={CustomersMenuIcon} className='me-2' />,
  },
]

export default _nav
